import React, { useState, useEffect, useRef } from "react";
import FolderIcon from "./img/folder.webp";
import MediaIcon from "./img/mediaIcon.png";
import sharepointIcon from "./img/spIcon.svg";
import { Button, Form, Spinner } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import { useConfig } from "./ConfigContext";
import { api } from "./pureFunctions";
import { SpinnerGroup } from "./Utils/SpinnerGroup";

export default function DropBoxExpo({ data, dbxData }) {
   const config = useConfig();
   const [show, setShow] = useState(false);
   const [loading, setLoading] = useState(false);
   const [state, setState] = useState(false);

   async function handleShow(open) {
      if (open) {
         const pdfPath = `${config.dbx.rootGrafik}${dbxData.name}/Expose_SRA3/Expose_${data.objektnr_extern}_web.pdf`;

         setLoading("loading");
         setShow(true);

         let objectUrl;
         let cancelled = false;

         if (!state.src) {
            try {
               let url, name;
               const r = await api.get(`/api/dropbox/pdf-link?path=${encodeURIComponent(pdfPath)}`).then((data) => {
                  console.log(data);
                  url = data.data.url;
                  name = data.data.name;
               });

               // Fetch the file and force the PDF type so the browser shows it inline
               const fileRes = await fetch(url);
               if (!fileRes.ok) throw new Error("Download failed");
               const blob = new Blob([await fileRes.arrayBuffer()], { type: "application/pdf" });
               objectUrl = URL.createObjectURL(blob);
               console.log(objectUrl);

               if (!cancelled) setState({ src: objectUrl, name, loading: false, error: null });
            } catch (e) {
               if (!cancelled) setState({ src: null, name: null, loading: false, error: e.message });
            }
         }
      } else {
         setShow(false);
         /*  try {
            URL.revokeObjectURL(state.src);
         } catch (error) {
            console.log(error);
         } */
      }
   }

   return (
      <>
         <button
            className="custom-button my-1"
            disabled={!dbxData.grafik}
            title="Expo anzeigen"
            onClick={(e) => {
               e.preventDefault();
               handleShow(true);
            }}
         >
            <img src={MediaIcon} />
            {" Expo Dropbox"}
         </button>

         <Modal show={show} dialogClassName="max-modal" onHide={() => handleShow(false)}>
            <Modal.Header closeButton>
               <Modal.Title>Exposé</Modal.Title>
            </Modal.Header>
            <Modal.Body>
               <div className="nachrichten-ubersicht">
                  <div style={{ flex: 1 }}>
                     {state.src ? (
                        <iframe
                           title={state.name}
                           src={state.src}
                           style={{ width: "100%", height: "calc(100vh - 160px)", border: "none" }}
                        />
                     ) : (
                        <>
                           {loading === "loading" && <SpinnerGroup />}
                           {loading === "error" && <span>Fehler beim Laden</span>}

                           {/* "Lade Exposé…" : error ? "Fehler beim Laden" : "Noch kein Exposé"} */}
                        </>
                     )}
                  </div>
               </div>
            </Modal.Body>
         </Modal>
      </>
   );
}
